'use strict';

var user = require('./user.js');
var endpointDesignGuideline = require('./endpointDesignGuideline.js');
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var FormMode = /*#__PURE__*/function (FormMode) {
  FormMode[FormMode["Update"] = 0] = "Update";
  FormMode[FormMode["Create"] = 1] = "Create";
  return FormMode;
}({});
var HttpCodeMap = {
  200: {
    code: 200,
    shortNameLocale: 'httpCode.shortName.200',
    messageLocale: 'httpCode.message.200'
  },
  201: {
    code: 201,
    shortNameLocale: 'httpCode.shortName.201',
    messageLocale: 'httpCode.message.201'
  },
  202: {
    code: 202,
    shortNameLocale: 'httpCode.shortName.202',
    messageLocale: 'httpCode.message.202'
  },
  204: {
    code: 204,
    shortNameLocale: 'httpCode.shortName.204',
    messageLocale: 'httpCode.message.204'
  },
  400: {
    code: 400,
    shortNameLocale: 'httpCode.shortName.400',
    messageLocale: 'httpCode.message.400'
  },
  401: {
    code: 401,
    shortNameLocale: 'httpCode.shortName.401',
    messageLocale: 'httpCode.message.401'
  },
  403: {
    code: 403,
    shortNameLocale: 'httpCode.shortName.403',
    messageLocale: 'httpCode.shortName.403'
  },
  404: {
    code: 404,
    shortNameLocale: 'httpCode.shortName.404',
    messageLocale: 'httpCode.message.404'
  },
  410: {
    code: 410,
    shortNameLocale: 'httpCode.shortName.410',
    messageLocale: 'httpCode.message.410'
  },
  422: {
    code: 422,
    shortNameLocale: 'httpCode.shortName.422',
    messageLocale: 'httpCode.message.422'
  },
  500: {
    code: 500,
    shortNameLocale: 'httpCode.shortName.500',
    messageLocale: 'httpCode.message.500'
  },
  502: {
    code: 502,
    shortNameLocale: 'httpCode.shortName.502',
    messageLocale: 'httpCode.message.502'
  },
  503: {
    code: 503,
    shortNameLocale: 'httpCode.shortName.503',
    messageLocale: 'httpCode.message.503'
  },
  504: {
    code: 504,
    shortNameLocale: 'httpCode.shortName.504',
    messageLocale: 'httpCode.message.504'
  }
};
var HttpCodeList = [HttpCodeMap[200], HttpCodeMap[201], HttpCodeMap[202], HttpCodeMap[204], HttpCodeMap[400], HttpCodeMap[401], HttpCodeMap[403], HttpCodeMap[404], HttpCodeMap[410], HttpCodeMap[422], HttpCodeMap[500], HttpCodeMap[502], HttpCodeMap[503], HttpCodeMap[504]];
var ResponseContentTypeMap = {
  text: {
    label: 'TEXT',
    value: 'text'
  },
  json: {
    label: 'JSON',
    value: 'json'
  },
  xml: {
    label: 'XML',
    value: 'xml'
  },
  html: {
    label: 'HTML',
    value: 'html'
  },
  raw: {
    label: 'Raw',
    value: 'raw'
  },
  binary: {
    label: 'Binary',
    value: 'binary'
  },
  noContent: {
    label: 'No-Content',
    value: 'noContent'
  },
  msgpack: {
    label: 'MsgPack',
    value: 'msgpack'
  },
  eventStream: {
    label: 'Event-Stream',
    value: 'eventStream'
  }
};
var ResponseContentType = /*#__PURE__*/function (ResponseContentType) {
  ResponseContentType["Json"] = "json";
  ResponseContentType["MsgPack"] = "msgpack";
  ResponseContentType["Xml"] = "xml";
  ResponseContentType["Html"] = "html";
  ResponseContentType["Raw"] = "raw";
  ResponseContentType["Binary"] = "binary";
  ResponseContentType["NoContent"] = "noContent";
  ResponseContentType["EventStream"] = "eventStream";
  ResponseContentType["Text"] = "text";
  return ResponseContentType;
}({});
var ResponseContentTypeList = [ResponseContentTypeMap.json, ResponseContentTypeMap.xml, ResponseContentTypeMap.html, ResponseContentTypeMap.raw, ResponseContentTypeMap.binary, ResponseContentTypeMap.noContent, ResponseContentTypeMap.msgpack, ResponseContentTypeMap.eventStream];
function isNoContentResponseType(value) {
  return value === ResponseContentTypeMap.noContent.value;
}
var HttpCodeOptions = HttpCodeList.map(function (item) {
  return {
    value: "".concat(item.code)
  };
});

// eslint-disable-next-line @typescript-eslint/no-empty-interface

var ModelType = /*#__PURE__*/function (ModelType) {
  ModelType["ProjectModule"] = "module";
  ModelType["HttpApi"] = "apiDetail";
  ModelType["WebSocketApi"] = "webSocketApi";
  ModelType["WebhookApi"] = "webhookApi";
  ModelType["ApiFolder"] = "apiDetailFolder";
  ModelType["ApiRootFolder"] = "apiDetailRootFolder";
  ModelType["HttpApiCase"] = "apiCase";
  ModelType["HttpApiMock"] = "apiMock";
  ModelType["WebSocketApiCase"] = "webSocketApiCase";
  ModelType["SocketService"] = "socketService";
  ModelType["SocketApi"] = "socketApi";
  ModelType["SocketApiCase"] = "socketApiCase";
  ModelType["SocketFolder"] = "socketFolder";
  ModelType["ApiSchema"] = "apiSchema";
  ModelType["ApiSchemaFolder"] = "apiSchemaFolder";
  ModelType["TestSuite"] = "testSuite";
  ModelType["TestSuiteFolder"] = "testSuiteFolder";
  ModelType["TestCaseFolder"] = "testCaseFolder";
  ModelType["Doc"] = "doc";
  ModelType["RequestFolder"] = "requestFolder";
  ModelType["HttpRequest"] = "httpRequest";
  ModelType["TestScenario"] = "testScenario";
  ModelType["ResponseFolder"] = "responseFolder";
  ModelType["HttpResponse"] = "httpResponse";
  ModelType["RequestHistory"] = "requestHistory";
  ModelType["DesignGuideline"] = "DesignGuideline";
  ModelType["ComplianceReport"] = "ComplianceReport";
  // 特殊场景使用, 没有找到使用场景，考虑删除
  ModelType["CreateHttpApi"] = "createApi";
  ModelType["CreateHttpApiCase"] = "createCase";
  ModelType["CreateWebSocketApi"] = "createWebSocketApi";
  ModelType["CreateWebSocketApiCase"] = "createWebSocketCase";
  ModelType["RpcFolder"] = "rpcFolder";
  ModelType["RpcMethod"] = "rpcMethod";
  ModelType["RpcModule"] = "rpcModule";
  ModelType["RpcService"] = "rpcService";
  ModelType["CUSTOM_ENDPOINT"] = "CUSTOM_ENDPOINT";
  ModelType["SOCKET_IO_API"] = "SOCKET_IO_API";
  ModelType["SECURITY_SCHEME_FOLDER"] = "SECURITY_SCHEME_FOLDER";
  ModelType["SECURITY_SCHEME"] = "SECURITY_SCHEME";
  ModelType["SECURITY_SCHEME_COMBINATION"] = "SECURITY_SCHEME_COMBINATION";
  ModelType["TEST_CASE"] = "TEST_CASE";
  return ModelType;
}({});
var NewModelType = /*#__PURE__*/function (NewModelType) {
  NewModelType["ApiFolder"] = "apiFolder";
  NewModelType["HttpApi"] = "httpApi";
  NewModelType["WebhookApi"] = "webhookApi";
  NewModelType["HttpApiCase"] = "httpApiCase";
  NewModelType["WebhookApiCase"] = "webhookApiCase";
  NewModelType["WebSocketApi"] = "webSocketApi";
  NewModelType["SocketService"] = "socketService";
  NewModelType["SocketApi"] = "socketApi";
  NewModelType["SocketApiCase"] = "socketApiCase";
  NewModelType["SocketFolder"] = "socketFolder";
  NewModelType["DataSchemaFolder"] = "dataSchemaFolder";
  NewModelType["DataSchema"] = "dataSchema";
  NewModelType["TestSuite"] = "testSuite";
  NewModelType["TestSuiteFolder"] = "testSuiteFolder";
  NewModelType["Doc"] = "doc";
  NewModelType["RequestFolder"] = "requestFolder";
  NewModelType["HttpRequest"] = "httpRequest";
  NewModelType["RpcMethod"] = "rpcMethod";
  NewModelType["RpcModule"] = "rpcModule";
  NewModelType["RpcService"] = "rpcService";
  NewModelType["ResponseFolder"] = "responseFolder";
  NewModelType["HttpResponse"] = "httpResponse";
  NewModelType["RpcMessage"] = "rpcMessage";
  NewModelType["CUSTOM_ENDPOINT"] = "CUSTOM_ENDPOINT";
  NewModelType["TEST_SCHEDULED_TASK"] = "TEST_SCHEDULED_TASK";
  NewModelType["TEST_SCHEDULED_TASK_FOLDER"] = "TEST_SCHEDULED_TASK_FOLDER";
  NewModelType["TEST_SCENARIO"] = "TEST_SCENARIO";
  NewModelType["TEST_SCENARIO_FOLDER"] = "TEST_SCENARIO_FOLDER";
  NewModelType["SECURITY_SCHEME_FOLDER"] = "SECURITY_SCHEME_FOLDER";
  NewModelType["SECURITY_SCHEME"] = "SECURITY_SCHEME";
  NewModelType["SOCKET_IO_API"] = "SOCKET_IO_API";
  NewModelType["MODULE"] = "MODULE";
  NewModelType["TEST_CASE"] = "TEST_CASE";
  return NewModelType;
}({});
var TreeNodeDropPosition = /*#__PURE__*/function (TreeNodeDropPosition) {
  TreeNodeDropPosition["Before"] = "-1";
  TreeNodeDropPosition["After"] = "1";
  TreeNodeDropPosition["Append"] = "0";
  TreeNodeDropPosition["Insert"] = "2";
  return TreeNodeDropPosition;
}({});
var DispatchActionType = /*#__PURE__*/function (DispatchActionType) {
  DispatchActionType[DispatchActionType["Fetch"] = 0] = "Fetch";
  DispatchActionType[DispatchActionType["Create"] = 1] = "Create";
  DispatchActionType[DispatchActionType["Update"] = 2] = "Update";
  DispatchActionType[DispatchActionType["Delete"] = 3] = "Delete";
  DispatchActionType[DispatchActionType["BulkDelete"] = 4] = "BulkDelete";
  DispatchActionType[DispatchActionType["Reorder"] = 5] = "Reorder";
  DispatchActionType[DispatchActionType["Duplicate"] = 6] = "Duplicate";
  DispatchActionType[DispatchActionType["Import"] = 7] = "Import";
  DispatchActionType[DispatchActionType["Other"] = 8] = "Other";
  DispatchActionType[DispatchActionType["Transfer"] = 9] = "Transfer";
  DispatchActionType[DispatchActionType["Dismiss"] = 10] = "Dismiss";
  DispatchActionType[DispatchActionType["Custom"] = 11] = "Custom";
  DispatchActionType[DispatchActionType["Clone"] = 12] = "Clone";
  DispatchActionType[DispatchActionType["Quit"] = 13] = "Quit";
  DispatchActionType[DispatchActionType["BulkAction"] = 14] = "BulkAction";
  return DispatchActionType;
}({});
var EnvironmentParameterType = /*#__PURE__*/function (EnvironmentParameterType) {
  EnvironmentParameterType["Query"] = "query";
  EnvironmentParameterType["Body"] = "body";
  EnvironmentParameterType["Cookie"] = "cookie";
  EnvironmentParameterType["Header"] = "header";
  return EnvironmentParameterType;
}({});
var EnvironmentParameterTypeMap = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, EnvironmentParameterType.Query, {
  label: 'Query',
  value: EnvironmentParameterType.Query
}), EnvironmentParameterType.Body, {
  label: 'Body',
  value: EnvironmentParameterType.Body
}), EnvironmentParameterType.Header, {
  label: 'Header',
  value: EnvironmentParameterType.Header
}), EnvironmentParameterType.Cookie, {
  label: 'Cookie',
  value: EnvironmentParameterType.Cookie
});
var EnvironmentParameterTypeMap_EN = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, EnvironmentParameterType.Query, {
  label: 'Query',
  value: EnvironmentParameterType.Query
}), EnvironmentParameterType.Body, {
  label: 'Body',
  value: EnvironmentParameterType.Body
}), EnvironmentParameterType.Header, {
  label: 'Headers',
  value: EnvironmentParameterType.Header
}), EnvironmentParameterType.Cookie, {
  label: 'Cookies',
  value: EnvironmentParameterType.Cookie
});
var EnvironmentParameterTypeList = [EnvironmentParameterTypeMap[EnvironmentParameterType.Header], EnvironmentParameterTypeMap[EnvironmentParameterType.Cookie], EnvironmentParameterTypeMap[EnvironmentParameterType.Query], EnvironmentParameterTypeMap[EnvironmentParameterType.Body]];
var EnvironmentParameterTypeList_EN = [EnvironmentParameterTypeMap_EN[EnvironmentParameterType.Header], EnvironmentParameterTypeMap_EN[EnvironmentParameterType.Cookie], EnvironmentParameterTypeMap_EN[EnvironmentParameterType.Query], EnvironmentParameterTypeMap_EN[EnvironmentParameterType.Body]];
var EnvironmentParameterTypeList_JP = EnvironmentParameterTypeList_EN;
var suggestHeaders = [{
  value: 'Accept'
}, {
  value: 'Accept-Charset'
}, {
  value: 'Accept-Encoding'
}, {
  value: 'Accept-Language'
}, {
  value: 'Access-Control-Request-Headers'
}, {
  value: 'Access-Control-Request-Method'
}, {
  value: 'Authorization'
}, {
  value: 'Cache-Control'
}, {
  value: 'Content-MD5'
}, {
  value: 'Content-Length'
}, {
  value: 'Content-Transfer-Encoding'
}, {
  value: 'Content-Type'
}, {
  value: 'Cookie'
}, {
  value: 'Date'
}, {
  value: 'Expect'
}, {
  value: 'From'
}, {
  value: 'Host'
}, {
  value: 'If-Match'
}, {
  value: 'If-Modified-Since'
}, {
  value: 'If-None-Match'
}, {
  value: 'If-Range'
}, {
  value: 'If-Unmodified-Since'
}, {
  value: 'Keep-Alive'
}, {
  value: 'Max-Forwards'
}, {
  value: 'Origin'
}, {
  value: 'Pragma'
}, {
  value: 'Proxy-Authorization'
}, {
  value: 'Range'
}, {
  value: 'Referer'
}, {
  value: 'TE'
}, {
  value: 'Trailer'
}, {
  value: 'Transfer-Encoding'
}, {
  value: 'Upgrade'
}, {
  value: 'User-Agent'
}, {
  value: 'Via'
}, {
  value: 'Warning'
},
// Non standard headers
{
  value: 'X-Requested-With'
}, {
  value: 'X-Do-Not-Track'
}, {
  value: 'DNT'
}, {
  value: 'x-api-key'
}];
var webSocketSuggestHeaders = [{
  value: 'Connection'
}, {
  value: 'Cookie'
}, {
  value: 'Host'
}, {
  value: 'Origin'
}, {
  value: 'Sec-WebSocket-Extensions'
}, {
  value: 'Sec-WebSocket-Key'
}, {
  value: 'Sec-WebSocket-Origin'
}, {
  value: 'Sec-WebSocket-Protocol'
}, {
  value: 'Sec-WebSocket-Version'
}, {
  value: 'Upgrade'
}, {
  value: 'User-Agent'
}];
var suggestContentTypes = [{
  value: 'application/atom+xml'
}, {
  value: 'application/ecmascript'
}, {
  value: 'application/json'
}, {
  value: 'application/vnd.api+json'
}, {
  value: 'application/javascript'
}, {
  value: 'application/octet-stream'
}, {
  value: 'application/ogg'
}, {
  value: 'application/pdf'
}, {
  value: 'application/postscript'
}, {
  value: 'application/rdf+xml'
}, {
  value: 'application/rss+xml'
}, {
  value: 'application/soap+xml'
}, {
  value: 'application/font-woff'
}, {
  value: 'application/x-msgpack'
}, {
  value: 'application/x-yaml'
}, {
  value: 'application/xhtml+xml'
}, {
  value: 'application/xml'
}, {
  value: 'application/xml-dtd'
}, {
  value: 'application/xop+xml'
}, {
  value: 'application/zip'
}, {
  value: 'application/gzip'
}, {
  value: 'application/graphql'
}, {
  value: 'application/x-www-form-urlencoded'
}, {
  value: 'audio/basic'
}, {
  value: 'audio/L24'
}, {
  value: 'audio/mp4'
}, {
  value: 'audio/mpeg'
}, {
  value: 'audio/ogg'
}, {
  value: 'audio/vorbis'
}, {
  value: 'audio/vnd.rn-realaudio'
}, {
  value: 'audio/vnd.wave'
}, {
  value: 'audio/webm'
}, {
  value: 'image/gif'
}, {
  value: 'image/jpeg'
}, {
  value: 'image/pjpeg'
}, {
  value: 'image/png'
}, {
  value: 'image/svg+xml'
}, {
  value: 'image/tiff'
}, {
  value: 'message/http'
}, {
  value: 'message/imdn+xml'
}, {
  value: 'message/partial'
}, {
  value: 'message/rfc822'
}, {
  value: 'multipart/mixed'
}, {
  value: 'multipart/alternative'
}, {
  value: 'multipart/related'
}, {
  value: 'multipart/form-data'
}, {
  value: 'multipart/signed'
}, {
  value: 'multipart/encrypted'
}, {
  value: 'text/cmd'
}, {
  value: 'text/css'
}, {
  value: 'text/csv'
}, {
  value: 'text/html'
}, {
  value: 'text/plain'
}, {
  value: 'text/vcard'
}, {
  value: 'text/xml'
}];
var LanguageMap = {
  'zh-CN': '简体中文',
  'en-US': 'English',
  'ja-JP': '日本語',
  'ko-KR': '한국어',
  'es-ES': 'Español (España)',
  'pt-BR': 'Português (Brasil)',
  'pt-PT': 'Português (Portugal)',
  'zh-TW': '繁體中文'
};
var SubLanguageMessageIdMap = {
  'zh-CN': 'app.setting.menu.language.local.zhCN',
  'en-US': 'app.setting.menu.language.local.enUS',
  'ja-JP': 'app.setting.menu.language.local.jaJP',
  'pt-PT': 'app.setting.menu.language.local.ptPT',
  'ko-KR': 'app.setting.menu.language.local.koKR',
  'es-ES': 'app.setting.menu.language.local.esES',
  'pt-BR': 'app.setting.menu.language.local.ptBR',
  'zh-TW': 'app.setting.menu.language.local.zhTW'
};
var FilterSample = /*#__PURE__*/function (FilterSample) {
  FilterSample["OFF"] = "0";
  FilterSample["ON"] = "1";
  return FilterSample;
}({});
var HistoryAction = /*#__PURE__*/function (HistoryAction) {
  HistoryAction["HISTORICAL"] = "HISTORICAL";
  HistoryAction["INSERT"] = "INSERT";
  HistoryAction["UPDATE"] = "UPDATE";
  HistoryAction["IMPORT"] = "IMPORT";
  HistoryAction["OVERRIDE"] = "OVERRIDE";
  HistoryAction["REVERT"] = "REVERT";
  HistoryAction["MERGE"] = "MERGE";
  HistoryAction["DELETE"] = "DELETE";
  HistoryAction["FORK"] = "FORK";
  HistoryAction["PICK"] = "PICK";
  HistoryAction["REBASE"] = "REBASE";
  return HistoryAction;
}({});
var Locales = /*#__PURE__*/function (Locales) {
  Locales["ZH_CN"] = "zh-CN";
  Locales["EN_US"] = "en-US";
  Locales["JA_JP"] = "ja-JP";
  Locales["PT_PT"] = "pt-PT";
  Locales["KO_KR"] = "ko-KR";
  Locales["ES_ES"] = "es-ES";
  Locales["PT_BR"] = "pt-BR";
  Locales["ZH_TW"] = "zh-TW";
  return Locales;
}({});
var LangMap = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, Locales.ZH_CN, '简体中文'), Locales.EN_US, 'English'), Locales.JA_JP, '日本語'), Locales.PT_PT, 'Português'), Locales.KO_KR, '한국어'), Locales.ES_ES, 'Español (España)'), Locales.PT_BR, 'Português (Brasil)'), Locales.ZH_TW, '繁體中文');
exports.USER_STATUS = user.USER_STATUS;
exports.EndpointDesignGuidelineTemplateType = endpointDesignGuideline.EndpointDesignGuidelineTemplateType;
exports.DispatchActionType = DispatchActionType;
exports.EnvironmentParameterType = EnvironmentParameterType;
exports.EnvironmentParameterTypeList = EnvironmentParameterTypeList;
exports.EnvironmentParameterTypeList_EN = EnvironmentParameterTypeList_EN;
exports.EnvironmentParameterTypeList_JP = EnvironmentParameterTypeList_JP;
exports.EnvironmentParameterTypeMap = EnvironmentParameterTypeMap;
exports.EnvironmentParameterTypeMap_EN = EnvironmentParameterTypeMap_EN;
exports.FilterSample = FilterSample;
exports.FormMode = FormMode;
exports.HistoryAction = HistoryAction;
exports.HttpCodeList = HttpCodeList;
exports.HttpCodeMap = HttpCodeMap;
exports.HttpCodeOptions = HttpCodeOptions;
exports.LangMap = LangMap;
exports.LanguageMap = LanguageMap;
exports.Locales = Locales;
exports.ModelType = ModelType;
exports.NewModelType = NewModelType;
exports.ResponseContentType = ResponseContentType;
exports.ResponseContentTypeList = ResponseContentTypeList;
exports.ResponseContentTypeMap = ResponseContentTypeMap;
exports.SubLanguageMessageIdMap = SubLanguageMessageIdMap;
exports.TreeNodeDropPosition = TreeNodeDropPosition;
exports.isNoContentResponseType = isNoContentResponseType;
exports.suggestContentTypes = suggestContentTypes;
exports.suggestHeaders = suggestHeaders;
exports.webSocketSuggestHeaders = webSocketSuggestHeaders;
